/**
 * Hot terms as the widget shows them: each term once (the entry with the highest count wins)
 * and largest count first. Chips are keyed by the term, so a repeated term made React keep
 * chips from the previous tab and the list looked unsorted.
 */
export default function uniqueTermsByCount(terms) {
  if (!Array.isArray(terms)) return [];
  const byTerm = new Map();
  terms.forEach((term) => {
    if (!term || typeof term.terms !== "string") return;
    const current = byTerm.get(term.terms);
    if (!current || (term.count || 0) > (current.count || 0)) {
      byTerm.set(term.terms, term);
    }
  });
  return [...byTerm.values()].sort((a, b) => (b.count || 0) - (a.count || 0));
}
